import { CreateReservation } from "@/models";
import { ReservationClient } from "@/models";
import { Context, createContext, useContext } from "react";
import { Day } from "../../-types";
import { ScheduleManager } from "../../-managers";

export type ReservationFirstStepModel = Omit<
  CreateReservation,
  "groupLeaderId"
>;
interface ReservationFormContext {
  reservation: ReservationFirstStepModel | null;
  setReservation: (
    val: ReservationFirstStepModel,
    updateDirty?: boolean,
  ) => void;
  setReservationValidator: (validator: () => boolean) => void;
  isEdit: boolean;
  isDirty: boolean;

  reservationClients: ReservationClient[];
  addReservationClient: (client: ReservationClient) => void;
  updateReservationClient: (
    clientId: number,
    client: ReservationClient,
  ) => void;
  removeReservationClient: (clientId: string) => void;
  setGroupLeader: (clientId: string) => void;
  groupLeaderId: number;
  setReservationClientValidator: (validator: () => boolean) => void;
  days: Day[];
  scheduleManager: Omit<ScheduleManager, "listen" | "ignore">;
}

const initialValue: ReservationFormContext = {
  reservation: null,
  isEdit: false,
  setReservation: () => {},
  setReservationValidator: () => {},
  isDirty: false,
  reservationClients: [],
  addReservationClient: () => {},
  updateReservationClient: () => {},
  removeReservationClient: () => {},
  setGroupLeader: () => {},
  groupLeaderId: 0,
  setReservationClientValidator: () => {},
  days: [],
  scheduleManager: null as unknown as ScheduleManager,
};

export const ReservationFormContext = createContext(
  initialValue,
) as Context<ReservationFormContext>;

export function useReservationFormContext() {
  return useContext<ReservationFormContext>(ReservationFormContext);
}
